import { HoleCameraControls } from './HoleCameraControls';

export const isHoleCameraControls = (controls: any): controls is HoleCameraControls => {
  return !!(controls && (controls as HoleCameraControls).isHoleCameraControls);
};
